const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@400;500;600;700&display=swap';

export const loadFont = () => {
  if (document.querySelector(`link[href="${FONT_HREF}"]`)) return;

  const link = document.createElement('link');

  link.rel = 'stylesheet';
  link.href = FONT_HREF;
  document.head.appendChild(link);
};
